import React, { Fragment, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TopNav } from "./navbar/top-nav";
import { NavLinks } from "./navbar/NavLinks";
import { getCompany } from "../../redux/Action/company";

const Layout = ({ children, ...props }) => {
  const dispatch = useDispatch();
  const { location } = useHistory();
  let { userDetail } = useSelector((state) => state.auth);

  const getCompanies = useCallback(() => {
    if (userDetail?._id) {
      dispatch(getCompany({ userId: userDetail._id }));
    }
  }, [dispatch, userDetail]);

  useEffect(() => {
    if (userDetail?._id) {
      getCompanies();
    }
  }, [userDetail, getCompanies]);

  if (location.pathname === "/invoice-preview") {
    return <div className="content--section">{children}</div>;
  } else
    return (
      <Fragment>
        <TopNav />
        {location.pathname === "/" || location.pathname === "/profile" ? (
          ""
        ) : (
          <NavLinks />
        )}
        <div className="content--section">{children}</div>
      </Fragment>
    );
};
export default Layout;
